import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const propTypes = exact({
  fileUrl: PropTypes.string.isRequired,
});

const ExcelOnlinePreview = (props) => {
  const { fileUrl } = props;
  const encodedUrl = encodeURIComponent(fileUrl);
  const embedUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}`;

  // NOTE: Not 100vh & vw to prevent double scrollbars. 98 Might not do it for smaller size screens
  // but it is a start. Feel free to tweak
  const style = {
    position: 'relative',
    height: '98vh',
    width: '98vw',
  };

  return (
    <div>
      <iframe
        style={style}
        title="spreadsheet"
        src={embedUrl}
        frameBorder="0"
      />
    </div>
  );
};

ExcelOnlinePreview.propTypes = propTypes;
export default ExcelOnlinePreview;
